import type {
    AddParticipantManuallyResponseType,
    AddParticipantManuallyRequestType
} from "./type";
import {
    request
} from "../request";

const threeTAddParticipantManually = async (args: AddParticipantManuallyRequestType): Promise<AddParticipantManuallyResponseType> => {
    return await request<AddParticipantManuallyResponseType>("/threeT/addParticipantManually", {
        body: JSON.stringify(args),
        method: "POST"
    });
};

export default threeTAddParticipantManually;
